import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Globe, Plugs, Sparkle } from '@phosphor-icons/react';
import SocialConnectionsSection from './SocialConnectionsSection';
import CreativeToolsPanel from './CreativeToolsPanel';
import AiCreditsSection from './AiCreditsSection';
import ContextHelpButton from '../ContextHelpButton';

const SECTIONS = [
  { id: 'social', icon: Globe, labelKey: 'project.connections.tabs.social' },
  { id: 'aiCredits', icon: Sparkle, labelKey: 'project.connections.tabs.aiCredits' },
  { id: 'creativeTools', icon: Plugs, labelKey: 'project.connections.tabs.creativeTools' },
];

// PRODUCT-IA-CLEANUP-001A (task section 5): the single Connections
// primary workspace, composing Social (connected profiles, OAuth/manual
// connection management) and Creative Tools (connector cards/workbench,
// formerly part of Creative Studio) as contextual groups — every
// existing connector endpoint/behavior is reused unchanged.
export default function ConnectionsWorkspace({ api, project, initialSection }) {
  const { t } = useTranslation();
  const [section, setSection] = useState(initialSection || 'social');

  useEffect(() => {
    if (initialSection) setSection(initialSection);
  }, [initialSection]);

  return (
    <div className="pt-2" data-testid="connections-workspace">
      <div className="mb-2 flex items-center gap-2 border-b border-[var(--border-color)]">
        <div className="flex min-w-0 flex-1 items-center gap-1.5 overflow-x-auto pb-1">
        {SECTIONS.map(item => (
          <button
            key={item.id}
            data-testid={`connections-tab-${item.id}`}
            className={`flex items-center gap-1.5 px-3 py-2 text-xs md:text-sm font-medium whitespace-nowrap border-b-2 transition-colors ${
              section === item.id
                ? 'border-[var(--accent-purple)] text-[var(--text-primary)]'
                : 'border-transparent text-[var(--text-muted)] hover:text-[var(--text-primary)]'
            }`}
            onClick={() => setSection(item.id)}
          >
            <item.icon size={16} weight={section === item.id ? 'fill' : 'regular'} />
            {t(item.labelKey)}
          </button>
        ))}
        </div>
        <ContextHelpButton articleId="social-connections" label="Guida Connessioni" className="mb-1" />
      </div>

      {section === 'social' && <SocialConnectionsSection api={api} project={project} />}
      {section === 'aiCredits' && <AiCreditsSection api={api} />}
      {section === 'creativeTools' && <CreativeToolsPanel api={api} project={project} />}
    </div>
  );
}
